import { gql } from "@apollo/client";

export const FETCH_ORDER_TAG_EXCLUSIONS = gql`
  query FetchTagBasedOrderExclusions {
    me {
      tagBasedOrderExclusions
    }
  }
`;

export const UPDATE_TAG_BASED_ORDER_EXCLUSIONS = gql`
  mutation UpdateTagBasedOrderExclusions(
    $tagBasedOrderExclusions: [JSONObject!]!
  ) {
    updateTagBasedOrderExclusions(
      tagBasedOrderExclusions: $tagBasedOrderExclusions
    )
  }
`;
